/* src/index.js
 * Entry point for React app
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/console.css';
import { initMarketingGtag } from './utils/marketingTracking';
import App from './App';

initMarketingGtag();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
